import React, { useEffect, useState, useContext } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import brLocale from 'date-fns/locale/pt-BR';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Button, Grid, TextField } from '@material-ui/core';
import Typography from "@material-ui/core/Typography";
import { Box } from '@mui/material';
import api from '../../services/api';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import './button.css';
import { i18n } from '../../translate/i18n';
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.padding,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(2),
    },
    modernTitle: {
        fontSize: "1.25rem",
        fontWeight: 700,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(2),
    },
    modernFilters: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
        flexWrap: "wrap",
    },
    modernButton: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        padding: theme.spacing(1, 2),
    },
    chartContainer: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(1),
    }
}));

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

export const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            position: 'top',
            display: false,
        },
        title: {
            display: false,
        },
        datalabels: {
            display: true,
            anchor: 'end',
            align: "end",
            color: "#333",
            font: {
                size: 12,
                weight: "600"
            },
        }
    },
    scales: {
        y: {
            beginAtZero: true,
            grid: {
                color: 'rgba(0, 0, 0, 0.05)',
            },
            ticks: {
                font: {
                    size: 11,
                }
            }
        },
        x: {
            grid: {
                display: false,
            },
            ticks: {
                font: {
                    size: 11,
                }
            }
        }
    },
};

export const ChatsUser = ({ initialDate: propInitialDate, finalDate: propFinalDate }) => {
    const classes = useStyles();
    const theme = useTheme();
    const [initialDate, setInitialDate] = useState(propInitialDate || new Date());
    const [finalDate, setFinalDate] = useState(propFinalDate || new Date());
    const [ticketsData, setTicketsData] = useState({ data: [] });
    const { user } = useContext(AuthContext);

    const companyId = user.companyId;

    useEffect(() => {
        if (propInitialDate) {
            setInitialDate(propInitialDate);
        }
    }, [propInitialDate]);

    useEffect(() => {
        if (propFinalDate) {
            setFinalDate(propFinalDate);
        }
    }, [propFinalDate]);

    useEffect(() => {
        if (companyId) {
            handleGetTicketsInformation();
        }
    }, [companyId, initialDate, finalDate]);

    const dataCharts = {

        labels: ticketsData && ticketsData?.data.length > 0 && ticketsData?.data.map((item) => item.nome),
        datasets: [
            {
                data: ticketsData?.data.length > 0 && ticketsData?.data.map((item, index) => {
                    return item.quantidade
                }),
                backgroundColor: theme.palette.primary.main,
            },

        ],
    };

    const handleGetTicketsInformation = async () => {
        try {

            const { data } = await api.get(`/dashboard/ticketsUsers?initialDate=${format(initialDate, 'yyyy-MM-dd')}&finalDate=${format(finalDate, 'yyyy-MM-dd')}&companyId=${companyId}`);
            setTicketsData(data);
        } catch (error) {
            toast.error(i18n.t("dashboard.toasts.ticketInfoError"));
        }
    }

    return (
        <>
            <Typography className={classes.modernTitle}>
                {i18n.t("dashboard.users.totalCallsUser")}
            </Typography>

            {!propInitialDate && (
                <Box className={classes.modernFilters}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
                        <DatePicker
                            value={initialDate}
                            onChange={(newValue) => { setInitialDate(newValue) }}
                            label={i18n.t("dashboard.date.initialDate")}
                            renderInput={(params) => <TextField {...params} size="small" variant="outlined" style={{ width: 180 }} />}
                        />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
                        <DatePicker
                            value={finalDate}
                            onChange={(newValue) => { setFinalDate(newValue) }}
                            label={i18n.t("dashboard.date.finalDate")}
                            renderInput={(params) => <TextField {...params} size="small" variant="outlined" style={{ width: 180 }} />}
                        />
                    </LocalizationProvider>
                    <Button 
                        className={classes.modernButton}
                        onClick={handleGetTicketsInformation} 
                        variant='contained'
                        color="primary"
                    >
                        Filtrar
                    </Button>
                </Box>
            )}
            <Box className={classes.chartContainer} style={{ height: '300px' }}>
                <Bar options={options} data={dataCharts} />
            </Box>
        </>
    );
}
